import { Component, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { Map, icon } from 'leaflet';
import { CstemapiService } from '../cstemapi.service';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {
  options;
  layers: any = [];
  map;
  marker;
  userLat = 23.040;
  userLong = 78.389;
  albidoFactor: any = [];
  aFactor;
  userLoc: any;
  albidoObj: any = {};
  popoverMsg: any;

  constructor(private cstemapi: CstemapiService, private auth: AuthService, private myRoute: Router) {
    this.userLoc = this.auth.getUserLocation();

    this.getAlbidoFactor();
  }


  ngOnInit() {
    this.aFactor = "4";
    this.auth.saveAlbidoId(4);

    this.options = {
      zoom: 12,
      center: L.latLng([this.userLoc.lat, this.userLoc.long]),
      timeDimension: true,
      timeDimensionControl: true,
      zoomControl: false,
      doubleClickZoom: false,
      scrollWheelZoom: false
    };

    var styled = L.gridLayer.googleMutant({
      type: 'roadmap', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
    });

    this.layers = [styled];

  }

  onMapReady(map: Map) {
    this.map = map;
    var vm = this;

    vm.marker = L.marker([this.userLoc.lat, this.userLoc.long], {
      icon: L.icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: 'assets/images/marker-icon.png',
        shadowUrl: 'assets/images/marker-shadow.png'
      })
    });
    vm.map.addLayer(vm.marker)
    vm.marker.bindPopup("<b>Selected Location</b>", {
      permanent: true,
      opacity: 1, bottom: '15px'
    }).openPopup();
  }

  getAlbidoFactor() {
    var dObj = {
      userId: this.auth.getUserId()
    };

    this.cstemapi.cstemAPI(dObj).GetAlbidoFactor.subscribe(data => {
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.albidoFactor = resData.albidoFactorList;
        this.aFactorRangeChange(4);
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting AlbidoFactor Type!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  aFactorRangeChange(id) {
    this.auth.saveAlbidoId(id);
    this.albidoObj = this.albidoFactor.find(alb => alb.albidoFactorId == id);

    this.popoverMsg = 'Range: ' + this.albidoObj.albido_min+ '- '+this.albidoObj.albido_max+', Default value: '+this.albidoObj.albido_default;
  }

  goToDashboard() {
    this.myRoute.navigate(['/dashboard'])
  }
  
}
